var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#man_icon_svg__clip0_1558_4889)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2DA3A",
    d: "M37 2v35H2V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 37a17.5 17.5 0 10-35 0h35z",
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.782 21.877a17.5 17.5 0 0117.5 0l-8.75 15.155-8.75-15.155z",
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.555,
    cy: 10.586,
    r: 4.375,
    transform: "rotate(90 19.555 10.586)",
    fill: "#5ACBBC",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 0.432,
    d: "M23.93 9.453v2.16H19.5v-2.16zM19.5 9.453v2.16h-4.32v-2.16z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#242424",
    strokeWidth: 3,
    d: "M37 2v35H2V2z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "man_icon_svg__clip0_1558_4889"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 37 2)",
    fill: "#fff",
    d: "M37 2h35v35H37z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNTU4XzQ4ODkpIj4KICAgICAgICA8cmVjdCB4PSIzNyIgeT0iMiIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAzNyAyKSIgZmlsbD0iI0YyREEzQSIvPgogICAgICAgIDxwYXRoIGQ9Ik0zNyAzN0MzNyAzNC43MDE5IDM2LjU0NzQgMzIuNDI2MiAzNS42Njc5IDMwLjMwM0MzNC43ODg0IDI4LjE3OTggMzMuNDk5NCAyNi4yNTA3IDMxLjg3NDQgMjQuNjI1NkMzMC4yNDkzIDIzLjAwMDYgMjguMzIwMiAyMS43MTE2IDI2LjE5NyAyMC44MzIxQzI0LjA3MzggMTkuOTUyNyAyMS43OTgxIDE5LjUgMTkuNSAxOS41QzE3LjIwMTkgMTkuNSAxNC45MjYyIDE5Ljk1MjcgMTIuODAzIDIwLjgzMjFDMTAuNjc5OCAyMS43MTE2IDguNzUwNjYgMjMuMDAwNiA3LjEyNTYzIDI0LjYyNTZDNS41MDA2MSAyNi4yNTA3IDQuMjExNTYgMjguMTc5OCAzLjMzMjExIDMwLjMwM0MyLjQ1MjY1IDMyLjQyNjIgMiAzNC43MDE5IDIgMzdMMTkuNSAzN0gzN1oiIGZpbGw9IiNGNjgyODIiIHN0cm9rZT0iIzI0MjQyNCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+CiAgICAgICAgPHBhdGggZD0iTTEwLjc4MjEgMjEuODc2NkMxMy40NDI0IDIwLjM0MDcgMTYuNDYwMiAxOS41MzIxIDE5LjUzMjEgMTkuNTMyMUMyMi42MDM5IDE5LjUzMjEgMjUuNjIxNyAyMC4zNDA3IDI4LjI4MjEgMjEuODc2NkwxOS41MzIxIDM3LjAzMjFMMTAuNzgyMSAyMS44NzY2WiIgZmlsbD0iIzc1NjNFNyIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxOS41NTQ3IiBjeT0iMTAuNTg1OSIgcj0iNC4zNzUiIHRyYW5zZm9ybT0icm90YXRlKDkwIDE5LjU1NDcgMTAuNTg1OSkiIGZpbGw9IiM1QUNCQkMiIHN0cm9rZT0iIzI0MjQyNCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+CiAgICAgICAgPHJlY3QgeD0iMjMuOTI5NyIgeT0iOS40NTMxMiIgd2lkdGg9IjIuMTYwNDkiIGhlaWdodD0iNC40MjkwMSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMjMuOTI5NyA5LjQ1MzEyKSIgZmlsbD0iIzc1NjNFNyIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjAuNDMyMDk5Ii8+CiAgICAgICAgPHJlY3QgeD0iMTkuNSIgeT0iOS40NTMxMiIgd2lkdGg9IjIuMTYwNDkiIGhlaWdodD0iNC4zMjA5OSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTkuNSA5LjQ1MzEyKSIgZmlsbD0iIzc1NjNFNyIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjAuNDMyMDk5Ii8+CiAgICA8L2c+CiAgICA8cmVjdCB4PSIzNyIgeT0iMiIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAzNyAyKSIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjMiLz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMTU1OF80ODg5Ij4KICAgICAgICAgICAgPHJlY3QgeD0iMzciIHk9IjIiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMzcgMikiIGZpbGw9IndoaXRlIi8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgManIcon as ReactComponent };